module.exports = __webpack_public_path__ + "_/_/src/components/toolbar/image/undo-icon-sleek-1.png";